import Glide from "@glidejs/glide";

function runOnStart() {
  try {
    const opt = {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      autoplay: 2500,
      focusAt: "center",
      perView: 1,
      gap: 24,
      // peek: 24,
      startAt: 1,
      // type:"carousel",
      hoverpause: true,
      arrows: {
        prev: ".glider-prev",
        next: ".glider-next",
      },
      // responsive: [
      //   {
      //     // screens greater than >= 775px
      //     breakpoint: 775,
      //     settings: {
      //       // Set to `auto` and provide item width to adjust to viewport
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       itemWidth: 300,
      //       duration: 0.25,
      //     },
      //   },
      //   {
      //     // screens greater than >= 1024px
      //     breakpoint: 1024,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       itemWidth: 300,
      //       duration: 0.25,
      //     },
      //   },
      // ],
    };
    const glide = new Glide(document.querySelector(".glider"), {...opt});
    const gliderHype = new Glide(document.querySelector(".glider-hype"), {...opt});
    // const glider = new Glide(document.querySelector(".glider-setores"), opt);
    glide.on(["run.after", "mount.after"], function () {
      // Handler logic ...
      // console.log("resise");
      window.dispatchEvent(new Event("resize"));
    });
    const track = document.getElementById("artistas");
    const track2 = document.getElementById("artistas2");
    track.classList.remove("hide");
    track2.classList.remove("hide");
    // glider.on(["run.after", "mount.after"], function () {
    //   // Handler logic ...
    //   console.log("resise");
    //   window.dispatchEvent(new Event("resize"));
    // });
    glide.mount();
    // glider.mount();
    gliderHype.mount();
  } catch (error) {
    console.log("Erro ao iniciar o glide", error);
  }
}

if (document.readyState !== "loading") {
  runOnStart();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runOnStart();
  });
}
